import { LinkButton } from '@euler/app/components/LinkButton';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { useOrderSearchNavigation } from '@euler/app/flows/search/screens';
import { FormGroup } from '@euler/components/form';
import { Input } from '@euler/components/form/Input';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { SafeHaptics } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';

export const LicensePlateNumberField = memo(() => {
  const { rpx } = useResponsiveContext();
  const { form } = useOrderSearchForm();

  const navigation = useOrderSearchNavigation();

  const onShowLicensePlateNoKeyboard = usePersistFn(() => {
    SafeHaptics.selection();
    navigation.navigate('_plate', {
      licensePlateNo: '',
      onDone: value => {
        form.licensePlateNo.update(value);
      },
    });
  });

  return (
    <FormGroup
      label="车牌号"
      labelContainerStyle={{ justifyContent: 'flex-start' }}
      labelRight={
        <LinkButton
          text="[从车牌键盘输入]"
          style={{ marginLeft: rpx(8) }}
          textStyle={{
            fontSize: rpx(11),
            lineHeight: rpx(18),
            fontFamily: FontFamily.NotoSans.Thin,
          }}
          onPress={onShowLicensePlateNoKeyboard}
        />
      }
    >
      <Input
        value={form.licensePlateNo.value ?? ''}
        placeholder="按车牌号搜索"
        onChangeText={form.licensePlateNo.update}
        clearButtonMode="always"
      />
    </FormGroup>
  );
});
